export default "__VITE_ASSET__ClvxXUxt__"